import { Transform } from '@pixi/math';

/**
 * Useless class. May be useful in the future.
 */
export class Live2DTransform extends Transform {
}
